import { ReactElement } from 'react';

import Subscription from '~components/Subscription';

import DashboardVariantV2CarrierContentCollectTabProvider, {
  useDashboardVariantV2CarrierContentCollectTabContext,
} from './Context';

import {
  DashboardVariantV2CarrierContentTabContainer,
  DashboardVariantV2CarrierContentWrapper,
} from '../../styles';

import {
  DashboardVariantV2CarrierContentCollectTabActions,
  DashboardVariantV2CarrierContentCollectTabCurrenFilters,
  DashboardVariantV2CarrierContentCollectTabDataTable,
  DashboardVariantV2CarrierContentCollectTabTracking,
} from './Components';

const DashboardVariantV2CarrierContentCollectTab = (): ReactElement => {
  const {
    showTracking: { value: showTracking },
  } = useDashboardVariantV2CarrierContentCollectTabContext();

  return (
    <DashboardVariantV2CarrierContentTabContainer>
      <DashboardVariantV2CarrierContentCollectTabActions />

      {!showTracking && (
        <DashboardVariantV2CarrierContentCollectTabCurrenFilters />
      )}

      <div>
        <Subscription.AvailableRoutesState.Alert
          withButtons
          withCloseAction
          sx={(currentTheme) => ({
            padding: currentTheme.spacing(0, 2, 2, 2),
          })}
        />
      </div>

      <DashboardVariantV2CarrierContentWrapper>
        {!showTracking && (
          <DashboardVariantV2CarrierContentCollectTabDataTable />
        )}

        {showTracking && <DashboardVariantV2CarrierContentCollectTabTracking />}
      </DashboardVariantV2CarrierContentWrapper>
    </DashboardVariantV2CarrierContentTabContainer>
  );
};

const DashboardVariantV2CarrierContentCollectTabWrapper = (): ReactElement => (
  <DashboardVariantV2CarrierContentCollectTabProvider>
    <DashboardVariantV2CarrierContentCollectTab />
  </DashboardVariantV2CarrierContentCollectTabProvider>
);

export default DashboardVariantV2CarrierContentCollectTabWrapper;
